import { render, staticRenderFns } from "./DocumentsPrintView.vue?vue&type=template&id=376139ac&"
import script from "./DocumentsPrintView.vue?vue&type=script&lang=ts&"
export * from "./DocumentsPrintView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports